import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import { IAuthLogin, IStateAuthStore } from "@/models/object";
import userService from "@/services/user";

import store from "@/store";

/**
 * Module d'authentification
 */
@Module({ namespaced: true, dynamic: true, store, name: "auth" })
export default class AuthModule extends VuexModule {
  /**
   * Le token
   * @type {string}
   */
  public token!: string;
  /**
   * L'url de veos
   * @type {string}
   */
  public url!: string;
}
